import _ from 'lodash'
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers } from 'redux'
import { Modal, ModalManager } from './index'
import initialValue from './form/reducers/sppbFormReducer.js'

import sppbForm from './form/reducers/sppbForm.js'
import formReducers from './form/reducers/FormReducer.js'

import PageBuilderFormWrap from './PageBuilderFormWrap'
import { Provider, connect } from 'react-redux'
import { saveSetting } from '../actions/index'

const reducer = combineReducers({
  sppbForm,
  form: formReducers,
})

const store = createStore(reducer)

class AddonForm extends Component {

  render() {
    const { addon, addonName, settings, toggleType } = this.props;

    return(
      <div className="sp-pagebuilder-modal-small">
        <Provider store = { store }>
          <PageBuilderFormWrap
            addon={addon}
            addonName = { addonName }
            onSubmit = { this.props.onSaveSettings }
            settings = { settings }
            toggleType={toggleType}
          />
        </Provider>
      </div>
    )
  }
}

export default AddonForm;



// WEBPACK FOOTER //
// ./src/helpers/AddonForm.js